<template>
  <div class="main-basic-info-header">
    <div class="main-basic-info-header__title">
        <h1 class="main-basic-info-header__title-brand">{{ brand }}</h1>
        <h2 class="main-basic-info-header__title-model">{{ model }}</h2>
    </div>
    <div class="main-basic-info-header__image" v-if="logo && !imageError">
        <img @error="imageLoadError" :src="logo" :alt="`logo ${brand} ${model}`"/>
    </div>
  </div>
</template>

<script>
export default {
  data:() => ({
    imageError:false
  }),
    props: {
        brand: {
            type: String,
            default: ''
        },
        model: {
            type: String,
            default: ''
        },
        logo: {
            type: String,
            default: ''
        }
    },
  methods:{
    imageLoadError(){
      this.imageError = true;
    }
  }
}
</script>
